import React from 'react';

export default function ThankPage() {
  return (
    <div className="thank-page d-flex flex-column align-items-center p-3">
      <h1 className="text-center">
        Vielen Dank für Ihr Interesse an unserer Dienstleistung!
      </h1>
      <div className="w-50 m-3" style={{ maxWidth: '200px' }}>
        <img src={process.env.REACT_APP_ROOT_DIRECTORY + "assets/images/success.svg"} alt="" />
      </div>
      <div className="d-flex flex-column justify-content-center align-items-center">
        <div>
          <p>
            Wir haben Ihre Anfrage erhalten und werten diese zeitnah aus. Unser
            Team wird sich kurzfristig mit Ihnen in Verbindung setzen um Ihre
            Anforderungen zu besprechen und Ihnen ein individuelles Angebot zu
            unterbreiten.
          </p>
          <p>
            Wenn Sie Fragen haben oder weitere Hilfe benötigen, zögern Sie
            nicht, uns zu kontaktieren.
          </p>
          <p>
            Wir danken Ihnen für Ihre Anfrage und hoffen Sie bei Ihrem Projekt
            unterstützen zu dürfen!
          </p>
          <p>
            Mit freundlichen Grüßen
            <br />
            VMT Solutions
          </p>
        </div>
      </div>
    </div>
  );
}
